import { createStyles } from '@mantine/core';

import dotsImage from '../../assets/dots.svg';

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  const isDarkMode = theme.colorScheme === 'dark';
  return {
    centerModal: {
      width: '100vw',
      // height: 'calc(100vh - 50px)',
      height: '100%',
      position: 'relative',
      overflowY: 'hidden',
      overflowX: 'hidden',
      maxWidth: '100%',
      margin: 'auto',
      display: 'flex',
      backgroundColor: colors.base.white,
      [`@media (min-width: ${theme.breakpoints.xs})`]: {
        width: '468px',
        minHeight: '540px',
        height: '600px',
        position: 'fixed',
        top: '54%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '12px',
        // border: `1px solid ${colors.disabled.muted}`,
        overflowY: 'visible',
        overflowX: 'visible',
        boxShadow: isDarkMode ? '0px 2px 8px 0px rgba(0, 0, 0, 0.60)' : ' 0px 0px 44px 0px #EAECF0',
        borderColor: isDarkMode ? colors.disabled.default : colors.disabled.muted,

      },
    },
    boxTopDesign: {
      position: 'absolute',
      top: '-20px',
      left: 0,
      zIndex: 11,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        display: 'none',
      },

    },
    dotsImage: {
      width: '113px',
    },
    gradientBorder: {
      width: '96%',
      height: '2px',
      background: 'linear-gradient(90deg, rgba(252, 252, 253, 0) -2.69%, #A54C85 49.73%, rgba(244, 236, 242, 0) 100%)',
    },
  };
});
const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();
export const ScreenWrapper = ({ children, className }: any) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.centerModal, className)}>
      <div className={classes.boxTopDesign}>
        <img className={classes.dotsImage} src={dotsImage} alt="dots" />
        <div className={classes.gradientBorder} />
      </div>
      {children}
    </div>
  );
};

export default ScreenWrapper;
